import CentricDispatcher from '../dispatcher/CentricDispatcher.react';
import { ActionTypes } from '../constants/CentricConstants';
import EventEmitter from 'events';
import assign from 'object-assign';

const CHANGE_EVENT = 'change';
const FORM_CHANGE_EVENT = 'form_change';

let _entities = [];

let CalendarEventStore = assign({}, EventEmitter.prototype, {

    emitChange: function() {
        this.emit(CHANGE_EVENT);
    },
    emitChangeForm: function() {
        this.emit(FORM_CHANGE_EVENT);
    },
    addChangeListener: function(callback) {
        this.on(CHANGE_EVENT, callback);
    },
    addFormChangeListener: function(callback) {
        this.on(FORM_CHANGE_EVENT, callback);
    },
    removeChangeListener: function(callback) {
        this.removeListener(CHANGE_EVENT, callback);
    },
    getAll: function() {
        return _entities.filter(function(e) { return e !== undefined; });
    },
    getDetails: function(eventId, calendarId) {
        return _entities.find(function(e) { return e !== undefined && e.eventId == eventId && e.calendarId == calendarId; });
    },
    getByEvent: function(id) {
        return _entities.filter(function(e) { return e !== undefined && e.eventId == id; });
    },
    getByCalendar: function(id) {
        return _entities.filter(function(e) { return e !== undefined && e.calendarId == id; });
    },
    add: function(entity) {
        if (entity !== undefined && entity.calendarId && entity.eventId) {
            let index = _entities.findIndex(function(e) { return e !== undefined && e.calendarId == entity.calendarId && e.eventId == entity.eventId; });
            if (0 <= index) {
                entity.loading = false;
                _entities[index] = entity;
            } else {
                _entities.push(entity);
            }
        }
    },
    remove: function(data) {
        if (data !== undefined && data.eventId && data.calendarId) {
            let index = _entities.findIndex(function(e) { return e !== undefined && e.calendarId == data.calendarId && e.eventId == data.eventId; });
            if (0 <= index) {
                if (data.deleted) {
                    delete _entities[index];
                } else {
                    _entities[index].loading = false;
                }
            }
        }
    }
    
});

CalendarEventStore.dispatchToken = CentricDispatcher.register(function(action) {

    switch(action.type) {
        case ActionTypes.CALENDAR_EVENT_LIST:
            action.data.forEach(CalendarEventStore.add);
            CalendarEventStore.emitChange();
            break;

        case ActionTypes.CALENDAR_EVENT_LIST_ERROR:
            CalendarEventStore.emitChange();
            break;
            
        default:
            break;
    }
});

export default CalendarEventStore;
